<script>
	import ContentPage from '@/components/pages/ContentPage'

	export default {
		name: 'FaqSubjectPage',
		extends: ContentPage
	}
</script>
